var React = require('react');

function NpCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.0678 48C37.3602 48 48.1371 37.2548 48.1388 24C48.1405 10.7452 37.3663 0 24.074 0C10.7817 0 0.00472199 10.7452 0.0030178 24C0.0013136 37.2548 10.7755 48 24.0678 48Z"}));
}

NpCircle.defaultProps = {"width":"49","height":"48","viewBox":"0 0 49 48"};

module.exports = NpCircle;

NpCircle.default = NpCircle;
